import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import { Popup } from '../../components/Popup';
import $ from "jquery";

const Find = (props) => {
  const [emailLocal, setEmailLocal] = useState('');
  const [emailDomain, setEmailDomain] = useState('naver.com');
  const [emailDirect, setEmailDirect] = useState('');
  const [showSelect, setShowSelect] = useState(false);
  const [step, setStep] = useState(1);
  const [popupMsg, setPopupMsg] = useState('');

  // Autofill can put a full address into the id box: split it into id + domain
  const onEmailLocalChange = (value) => {
    const at = value.indexOf('@');
    if (at < 0) return setEmailLocal(value);
    const domain = value.slice(at + 1).trim();
    setEmailLocal(value.slice(0, at));
    if (['naver.com', 'hanmail.net', 'daum.net', 'kakao.com', 'gmail.com'].includes(domain)) handleEmailDomainChange(domain);
    else { setEmailDomain('직접입력'); setEmailDirect(domain); }
  };

  const handleEmailDomainChange = (domain) => {
    setEmailDomain(domain);
    if (domain !== '직접입력') setEmailDirect('');
  };

  const handleFind = async () => {
    const finalEmailDomain = emailDomain === '직접입력' ? emailDirect : emailDomain;
    if (!emailLocal || !finalEmailDomain) {
      alert('이메일을 입력해주세요.');
      return;
    }
    const fullEmail = `${emailLocal}@${finalEmailDomain}`;

    try {
      await axios.post('/api/auth/find', { email: fullEmail });
      setPopupMsg('임시 비밀번호가 이메일로 발송되었습니다.');
      setStep(2);
    } catch (err) {
      console.error(err);
      if (err.response && err.response.status === 404) {
        setPopupMsg('등록된 이메일이 없습니다.');
      } else {
        setPopupMsg('오류가 발생했습니다.');
      }
      // Show popup for error case (on step 1)
      $('.no-mail').show();
    }
  };

  return (
    <Layout header={{ title: '계정찾기', Backbtn: true, link: '/Login' }} containName='account'>

      <Popup popupName='no-mail' btn confirmtext='확인' onConfirm={() => $('.no-mail').hide()}>
        {popupMsg}
      </Popup>

      {step === 1 && (
        <div className="find-step01">
          <div className="input-wrap">
            <label htmlFor="email">이메일</label>
            <div className="input-group">
              <div className="input-wrap">
                <input type="text" id="email" placeholder="이메일" value={emailLocal} onChange={e => onEmailLocalChange(e.target.value)} autoComplete="username" />
              </div>
              <div className="sign">@</div>
              <div className="input-wrap">
                <div className="select">
                  <button type="button" onClick={() => setShowSelect(!showSelect)}>{emailDomain}</button>
                  <ul style={{ display: showSelect ? 'block' : 'none' }}>
                    {['naver.com', 'hanmail.net', 'daum.net', 'kakao.com', 'gmail.com', '직접입력'].map(d => (
                      <li key={d} onClick={() => { handleEmailDomainChange(d); setShowSelect(false); }}>{d}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            {emailDomain === '직접입력' && (
              <input type="text" id="email_direct" placeholder="직접 입력해주세요" value={emailDirect} onChange={e => setEmailDirect(e.target.value)} style={{ display: 'block' }} />
            )}
          </div>
          <button type="button" className="btn" onClick={handleFind}>임시 비밀번호 발송</button>
        </div>
      )}

      {step === 2 && (
        <div className="find-step02" style={{ display: 'block' }}>
          <div className="input-group" style={{ display: 'block', textAlign: 'center', padding: '40px 0' }}>
            <p className="text-guide" style={{ fontSize: '16px', lineHeight: '1.5' }}>{popupMsg}</p>
            <p className="text-guide" style={{ marginTop: '10px', color: '#999' }}>로그인 후 비밀번호를 변경해주세요.</p>
          </div>
          <Link to="/Login" className="btn">로그인 하러가기</Link>
        </div>
      )}

    </Layout>
  );
};

export default Find;